import Action from '@/scripts/libs/action';

// define a mixin object
const actionGeneratorMixin = {
  computed: {
    actionGeneratorMixin_actions() {
      return (this.actions || [])
        .map(action => new Action(action, this.props))
        .filter(action => action.show)
      ;
    },
  },
};

export default actionGeneratorMixin;
